import React from 'react';

import styled from 'styled-components';
import { arrayOf, func, string } from 'prop-types';

import Theme from '../theme/Theme';

const ToogleMetrics = ({ data, onToogle, value, toggleName }) => {
  return (
    <Wrapper>
      <div className="toggle-container">
        <ul className="toggle-tab">
          {data?.map((item) => {
            return (
              <li key={item.id}>
                <input
                  id={item.name}
                  className="d-none"
                  type="radio"
                  name={toggleName}
                  value={item.name}
                  checked={value === item.name}
                  onClick={(event) => {
                    onToogle(item.name, event);
                  }}
                  onChange={() => {}}
                />
                <label htmlFor={item.name}>{item.label}</label>
              </li>
            );
          })}
        </ul>
      </div>
    </Wrapper>
  );
};

export default ToogleMetrics;

export const Wrapper = styled.div`
  margin-bottom: 13px;

  .toggle-container {
    background-color: ${Theme.white};
    border: 1px solid ${Theme.gray45};
    border-radius: 5px;
    width: 100%;

    &.toggle-block {
      border: none;
    }

    ul.toggle-tab {
      list-style-type: none;
      padding: 0;
      margin: 0;

      li input[type='radio']:checked + label {
        background-color: ${Theme.white};
        border: 1px solid ${Theme.orange};
        border-radius: 5px;
        color: ${Theme.orange};
        width: 100%;
        text-align: center;
      }

      li {
        display: inline-block;
        width: 50%;

        &.toggle-item {
          border: 1px solid ${Theme.gray45};
          border-radius: 5px;
          margin-right: 5px;
          width: auto;
          font-family: ${Theme.titleFontFamily};
          margin-bottom: 5px;

          &:last-child {
            margin-right: 0;
          }
        }

        label {
          color: ${Theme.gray40};
          padding: 3px 2px;
          font-size: ${Theme.verySmall};
          font-family: ${Theme.titleFontFamily};
          display: inline-block;
          cursor: pointer;
          text-align: center;
          width: 100%;
        }
      }
    }
  }
`;

ToogleMetrics.defaultProps = {
  toggleName: '',
  data: [],
  onToogle: () => {},
  value: '',
};

ToogleMetrics.propTypes = {
  data: arrayOf(Array),
  onToogle: func,
  value: string,
  toggleName: string,
};
